<template>
  <section class="profile-layout">
    <div class="profile-layout__navigation">
      <navigation-tabs
        class="pb-2 pt-3"
        :links="navigationTabs"
        :is-reactive="true"
      />
    </div>
    <div class="profile-layout__content">
      <div
        v-if="$route.name === 'profile-overview' && $slots.readme"
        class="profile-layout__readme"
      >
        <slot name="readme"></slot>
      </div>
      <div
        v-else-if="isAuthUserProfile && $route.name === 'profile-overview'"
        class="profile-layout__readme --empty"
      >
        {{ $t('profile.readme.none') }}
        <a href="https://docs.gitflic.ru/profile/readme">{{ $t('profile.readme.title') }}</a>
      </div>
      <router-view />
    </div>
  </section>
</template>

<script>
import NavigationTabs from '@shared/shared-components/shared/navigation-tabs';
import ProfileMessages from '@shared/modules/profile/profile.messages';

export default {
  name: 'ProfileLayout',
  components: { NavigationTabs },
  computed: {
    navigationTabs() {
      return [
        {
          title: this.$t('profile.title'),
          to: {
            name: 'profile-overview',
            params: { userAlias: this.userAlias }
          }
        },
        {
          title: this.$t('profile.projects.title'),
          to: {
            name: 'profile-projects',
            params: { userAlias: this.userAlias }
          }
        },
        {
          title: this.$t('profile.subscriptions.title'),
          to: {
            name: 'profile-subscriptions',
            params: { userAlias: this.userAlias }
          }
        },
        {
          title: this.$t('profile.followers.title'),
          to: {
            name: 'profile-followers',
            params: { userAlias: this.userAlias }
          }
        },
        {
          title: this.$t('profile.favorites.title'),
          to: {
            name: 'profile-favorites',
            params: { userAlias: this.userAlias }
          }
        }
      ];
    },
    userAlias() {
      return this.$route.params.userAlias;
    },
    isAuthUserProfile() {
      return this.userAlias === this.$store.getters.getUserAlias;
    }
  },
  i18n: {
    messages: ProfileMessages
  }
};
</script>

<style lang="scss">
$this: '.profile-layout';

#{$this} {
  margin-top: 4px;

  #{$this}__navigation {
    margin-bottom: 8px;
  }

  #{$this}__content {
    display: flex;
    flex-direction: column;
    gap: 24px;

    #{$this}__readme {
      padding: 16px;
      background-color: var(--light);
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius-lg);
      word-break: break-word;

      &.--empty {
        text-align: center;
      }

      & img {
        max-width: 100%;
      }
    }
  }
}
</style>
